import React, { FC } from "react";
import st from "./index.module.scss";

export const FocusSlide: FC = () => {
  return (
    <div className={st.container}>
      <div className={st["overlay-shelf"]} />
      <div className={st["inner-container"]}>
        <div className={st.rightSide}>
          <div className={st.cans} />
          <div className={st.bar} />
        </div>
      </div>
    </div>
  );
};
